module.exports = __webpack_public_path__ + "img/asta_web.ce730321.webp";